export const isInClaw = () => {
  return /MarioClaw/i.test(navigator.userAgent);
};